import { CountryCode } from '~shared/constants/country-code.enum';
import {
  DE_BUYER_SUPPORT_EXTERNAL_LINK,
  ES_BUYER_SUPPORT_EXTERNAL_LINK, FR_BUYER_SUPPORT_EXTERNAL_LINK,
  IT_BUYER_SUPPORT_EXTERNAL_LINK, NL_BUYER_SUPPORT_EXTERNAL_LINK,
  PT_BUYER_SUPPORT_EXTERNAL_LINK
} from '~shared/constants/links.constants';

export const SupportHelpCenterLink = {
  [CountryCode.Germany]: DE_BUYER_SUPPORT_EXTERNAL_LINK,
  [CountryCode.Spain]: ES_BUYER_SUPPORT_EXTERNAL_LINK,
  [CountryCode.Italy]: IT_BUYER_SUPPORT_EXTERNAL_LINK,
  [CountryCode.Portugal]: PT_BUYER_SUPPORT_EXTERNAL_LINK,
  [CountryCode.Netherlands]: NL_BUYER_SUPPORT_EXTERNAL_LINK,
  [CountryCode.France]: FR_BUYER_SUPPORT_EXTERNAL_LINK
};
